import StripeConnect from 'shared/components/molecules/StripeConnect/StripeConnect';

export default StripeConnect;
